import React, { useState } from 'react';
import { isToday } from 'date-fns';
import I18N from '@leverege/i18n';
import { Attributes } from '@leverege/ui-attributes';
import { Dialog, Flex, Pane, Content, Button, Text } from '@leverege/ui-elements';
import { LoadingScreen } from '@leverege/molten/screens';
import { TitleBar } from '@leverege/ui-plugin';
import RecovrReconciliation from '../../util/RecovrReconciliation';
import { isReconcilableOperationState } from './Util';
import { isPositionRequestableByOperationStateAndConfig, isPositionRequestableByStateConfigVersionNumber } from '../positionRequest/Util';
import S from './LocatorDialog.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.locator.reconcile.LocatorDialog');
export default function LocatorDialog(props) {
  const {
    show,
    onClose,
    actions,
    locator
  } = props;
  const [loading, setLoading] = useState(false);
  const onOkay = async () => {
    setLoading(true);
    await RecovrReconciliation.reconcileLocator({
      actions,
      onClose,
      locator
    });
    setLoading(false);
    onClose();
  };

  // assume this can only be in the past?
  const lastPositionRequest = Attributes.get('locator.positionRequestMetadata.createdAt', 'locator', locator?.data);
  const reportedOperationState = Attributes.get('locator.reportedOperationState', 'locator', locator?.data);
  let disabled, disabledMessage;
  if (isToday(new Date(lastPositionRequest || 0))) {
    disabled = true;
    disabledMessage = t('rateLimitDisabledMessage');
  } else if (!isReconcilableOperationState(reportedOperationState)) {
    disabled = true;
    disabledMessage = t('operationStateDisabledMessage');
  } else if (!isPositionRequestableByStateConfigVersionNumber(locator) && !isPositionRequestableByOperationStateAndConfig(locator)) {
    disabled = true;
    disabledMessage = t('disabledMessage');
  }
  return /*#__PURE__*/_jsx(Dialog, {
    show: show,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Content, {
      relative: true,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: "dialogHeader",
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "dialogTitle",
          title: t('title'),
          icon: tIcon('titleIcon')
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: "dialogBody",
        children: loading ? /*#__PURE__*/_jsx(Pane, {
          children: /*#__PURE__*/_jsx(LoadingScreen, {
            title: t('loadingTitle')
          })
        }) : /*#__PURE__*/_jsx(Flex, {
          variant: "colM",
          children: disabled ? /*#__PURE__*/_jsx(Pane, {
            className: S.messageContainer,
            children: /*#__PURE__*/_jsxs(Flex, {
              variant: "row",
              align: "start",
              children: [/*#__PURE__*/_jsx(Text, {
                icon: tIcon('disabledIcon'),
                className: S.messageIcon
              }), /*#__PURE__*/_jsx(Text, {
                className: S.messageText,
                children: disabledMessage
              })]
            })
          }) : /*#__PURE__*/_jsx(Text, {
            className: S.messageText,
            children: t('enabledMessage')
          })
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        variant: "dialogFooter",
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: loading,
          variant: "secondary",
          onClick: onClose,
          children: t('cancel')
        }), /*#__PURE__*/_jsx(Button, {
          disabled: loading || disabled,
          variant: "primary",
          onClick: onOkay,
          children: t('confirm')
        })]
      })]
    })
  });
}